// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadTaxesButton_downloadButton__2UiqZ"};